import type { Participant } from '../party';

interface ParticipantsProps {
  participants: Record<string, Participant>;
  leader: string | null;
  currentUserId: string;
  onToggleLead: () => void;
  compact?: boolean;
}

export default function Participants({
  participants, leader, currentUserId, onToggleLead, compact,
}: ParticipantsProps) {
  const users = Object.values(participants);
  const isLeader = leader === currentUserId;
  const leaderUser = leader ? participants[leader] : null;

  return (
    <div className={`participants-bar ${compact ? 'compact' : ''}`}>
      <div className="participants-avatars">
        {users.map((user) => (
          <div
            key={user.userId}
            className={`participant ${user.userId === leader ? 'leader' : ''}`}
            title={user.username}
          >
            <img
              className="participant-avatar"
              src={user.avatar}
              alt={user.username}
              style={{ borderColor: user.color }}
            />
            {user.userId === leader && <span className="leader-crown">&#x1F451;</span>}
          </div>
        ))}
      </div>

      <div className="participants-info">
        {users.length} user{users.length !== 1 ? 's' : ''} viewing
        {leaderUser && !isLeader && (
          <span className="following-text">
            &middot; Following {leaderUser.username}
          </span>
        )}
      </div>

      <div className="participants-actions">
        <button
          className={`lead-btn ${isLeader ? 'active' : ''}`}
          onClick={onToggleLead}
          title={isLeader ? 'Stop leading' : 'Lead navigation'}
        >
          {isLeader ? 'Stop Leading' : 'Lead'}
        </button>
      </div>
    </div>
  );
}
